import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { withRouter } from 'react-router'

import logo from '../../kiosk/assets/images/logo_order_next.png'

import CircleBackground from '../CircleBackground'
import Button from '../components/Button'

import Environment from '../../utils/environment'

if (!Environment.node.isTest) {
  Modal.setAppElement('#root')
}

export class ScannedScreen extends Component {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    toggleAppState: PropTypes.func.isRequired,
  }

  state = {
    seconds: 15,
  }

  intervalID = null

  componentDidMount() {
    this.setTimer()
  }

  componentDidUpdate() {
    if (this.state.seconds === 0) {
      this.goIdle()
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalID)
  }

  setTimer = () => {
    clearInterval(this.intervalID)
    this.intervalID = setInterval(this.updateTimer, 1000)
  }

  updateTimer = () => {
    if (this.state.seconds > 0) {
      this.setState(({ seconds }) => ({ seconds: seconds - 1 }))
    }
  }

  goBack = () => this.props.history.push('/kiosk/order/payment')

  goIdle = () => this.props.history.push('/kiosk/attract_loop')

  backButtonTitle = () => this.state.seconds > 10 ? 'Close' : `Close in ${this.state.seconds}...`

  render() {
    return (
      <div className="payment -card-only">
        <div className="payment__logo">
          <img src={logo} alt="logo" />
        </div>
        <div className="payment__header">Scanned!</div>
        <div className="payment__label">Complete this order on your phone.</div>
        <CircleBackground>
          <img src="/teamLogo.png" alt="team-logo" />
        </CircleBackground>
        <div className="payment__actions">
          <Button
            className="rounded-btn -progress -progress-delayed -dark"
            onClick={this.goIdle}
            title={this.backButtonTitle()}
          />
        </div>
      </div>
    )
  }
}

export default withRouter(ScannedScreen)
